import type { SpaceProps as MantineSpaceProps } from '@mantine/core';
import { Space as MantineSpace } from '@mantine/core';

type SpaceProps = MantineSpaceProps;

export const Space = (props: SpaceProps) => {
  return <MantineSpace {...props} />;
};
